// extracted by mini-css-extract-plugin
module.exports = {"toggleLayout":"styles_toggleLayout__YH0JX","togglePrivate":"styles_togglePrivate__Z_l2m"};